export default function (dateString) {
  const date = new Date(dateString)
  const hour = date.getHours()
  const minute = date.getMinutes()
  const day = date.getDate()
  const month = date.toLocaleString('default', { month: 'long' })
  const year = date.getFullYear()
  return `${hour}:${minute} ${day} ${month} ${year}`
}
